'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _index = require('../index');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var babelPluginFlowReactPropTypes_proptype_CommonType = require('appkit-react-utils/commonType').babelPluginFlowReactPropTypes_proptype_CommonType || require('prop-types').any;

var ModalHeader = function ModalHeader(_ref) {
  var style = _ref.style,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      children = _ref.children,
      closable = _ref.closable,
      onClick = _ref.onClick,
      others = _objectWithoutProperties(_ref, ['style', 'className', 'children', 'closable', 'onClick']);

  var classNames = (0, _classnames2.default)('modal-header', className, {
    "a-increase-child-color-level-by-1": !(className && className.includes("a-increase-child-color-level-by"))
  });
  var handleClick = function handleClick(e) {
    if (closable !== false && onClick) {
      onClick(e);
    }
  };
  return React.createElement(
    'div',
    Object.assign({ className: classNames, style: style }, others),
    children,
    closable !== false && React.createElement(_index.KODIV, { className: 'appkiticon icon-close-fill a-close-btn', onClick: handleClick })
  );
};

ModalHeader.propTypes = Object.assign({}, {
  closable: require('prop-types').bool,
  onClick: require('prop-types').func,
  children: require('prop-types').node
}, babelPluginFlowReactPropTypes_proptype_CommonType === require('prop-types').any ? {} : babelPluginFlowReactPropTypes_proptype_CommonType);
ModalHeader.propTypes = {
  style: _propTypes2.default.object,
  className: _propTypes2.default.string,
  closable: _propTypes2.default.bool,
  onClick: _propTypes2.default.func
};
ModalHeader.displayName = 'ModalHeader';

exports.default = ModalHeader;